export interface AssetFailureTicketContext {
    fileName: string;
    assetId?: string;
    trackingId?: string;
    error: string;
    source: 'Tenant Asset Ingestion' | 'Super Admin Asset Upload';
    attempts: number;
}

const COUNTS_KEY = 'asset_upload_failure_counts';
export const TICKET_CONTEXT_KEY = 'asset_upload_ticket_context';

const readCounts = (): Record<string, number> => {
    try {
        return JSON.parse(sessionStorage.getItem(COUNTS_KEY) || '{}');
    } catch {
        return {};
    }
};

export const recordAssetUploadFailure = (
    key: string,
    context: Omit<AssetFailureTicketContext, 'attempts'>
): number => {
    const counts = readCounts();
    const attempts = (counts[key] || 0) + 1;
    counts[key] = attempts;
    sessionStorage.setItem(COUNTS_KEY, JSON.stringify(counts));

    if (attempts >= 3) {
        sessionStorage.setItem(TICKET_CONTEXT_KEY, JSON.stringify({ ...context, attempts }));
        delete counts[key];
        sessionStorage.setItem(COUNTS_KEY, JSON.stringify(counts));
        window.location.assign('/tickets/raise');
    }

    return attempts;
};

export const clearAssetUploadFailures = (key: string): void => {
    const counts = readCounts();
    delete counts[key];
    sessionStorage.setItem(COUNTS_KEY, JSON.stringify(counts));
};
